import React from "react";
import { Box, Typography, Paper, Link } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function ResetPassCheckEmail() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: "80vw",
        mx: "auto",
        display: "flex",
        flexDirection: "column",
        gap: 3,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper elevation={1} sx={{ p: "1rem", textAlign: "center" }}>
        <Typography variant="h5" gutterBottom>
          {t("Επιτυχής αρχικοποίηση και αποστολή κωδικού πρόσβασης")}
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          {t(
            "Ελέγξτε το e-mail σας. Ο νέος κωδικός πρόσβασης θα σταλεί εκεί σε λίγα λεπτά.",
          )}
        </Typography>
        <Link href="/" variant="body2">
          {t("Επιστροφή στην οθόνη εισόδου")}
        </Link>
      </Paper>
    </Box>
  );
}
